// Analytics Plausible — événements custom (cookieless, RGPD). No-op tant que le script Plausible n'est
// pas chargé (dev, ou domaine hojin.ai pas encore créé côté compte Plausible). Jamais d'exception à l'écran.
declare global {
  interface Window {
    plausible?: (event: string, opts?: { props?: Record<string, string | number | boolean> }) => void;
  }
}

/** Émet un événement Plausible (best-effort). Événements minimaux : "CTA principal", "Début saisine". */
export function track(event: string, props?: Record<string, string | number | boolean>): void {
  if (typeof window === "undefined") return;
  try {
    window.plausible?.(event, props ? { props } : undefined);
  } catch {
    /* analytics ne casse jamais l'app */
  }
}
